// extracted by css-extract-rspack-plugin
export default {"InfoBlockButton":"kZUGI","HelpExternalLink":"d9imV"};